module.exports = __webpack_public_path__ + "static/media/voterid.78791bac.jpeg";